import type { Report } from '@/models/report';
import { getEntityQueryOptions } from '@/queries/getEntityQueryOptions';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import WidgetsComponent from '@/components/view-report/widgets';
import { ReportParameters } from '@/components/report-components/report-parameters';

export const Route = createFileRoute(
    '/_app/$module_id/$entity_type_id/$entity_id/_tabs/view-report/',
)({
    component: RouteComponent,
    loader: async ({ context: { queryClient }, params }) => {

        const { entity_type_id, entity_id } = params;
        await queryClient.ensureQueryData(getEntityQueryOptions(entity_type_id, entity_id));
    }
})

function RouteComponent() {

    const { entity_type_id, entity_id } = Route.useParams();
    const { data } = useQuery(getEntityQueryOptions(entity_type_id, entity_id));

    const entity = data?.entity as Report;

    return (
        <div className='flex flex-col gap-4  w-[calc(100%)]'>
            <ReportParameters parameters={entity.parameters || []} />
            <div className='bg-white mt-5 p-5 shadow rounded-md w-full'>
                <WidgetsComponent widgets={entity.widgets || []} report={entity} editable={false} />
            </div>
        </div>
    )
}
